import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const TermsOfUseOfTheWebsite = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      3. Warunki korzystania z Serwisu i z Usług.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>3.1.</ListItemIcon>
        <ListItemText>
          Korzystanie z Serwisu i z dostępnych w nim Usług jest dobrowolne.
          Użytkownik nie ponosi opłat na rzecz Administratora związanych z
          korzystaniem z Serwisu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.2.</ListItemIcon>
        <ListItemText>
          Korzystanie z Serwisu i z dostępnych w nim Usług jest możliwe po
          zakończeniu procedury rejestracyjnej oraz aktywacji Konta.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.3.</ListItemIcon>
        <ListItemText>
          Rejestracja Konta w Serwisie następuje po realizacji przez Użytkownika
          wszystkich kroków wskazanych na stronie internetowej Serwisu, w tym:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                wypełnieniu formularza rejestracyjnego,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>zaakceptowaniu Regulaminu,</ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>aktywacji Konta.</ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.4.</ListItemIcon>
        <ListItemText>
          Użytkownik powinien zapoznać się z treścią Regulaminu przed
          rozpoczęciem korzystania z Usług.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.5.</ListItemIcon>
        <ListItemText>
          W zakresie nieuregulowanym w Regulaminie, zastosowanie ma ustawa z
          dnia 18.07.2002 r. o świadczeniu usług drogą elektroniczną (t.j. Dz.U.
          z 2020 r., poz. 344, z późn. zm.), ustawa z dnia 23.04.1964 r. Kodeks
          cywilny (t.j. Dz.U. z 2020 r., poz. 1740, z późn. zm.) oraz inne
          przepisy powszechnie obowiązującego prawa polskiego.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.6.</ListItemIcon>
        <ListItemText>
          Poprzez akceptację Regulaminu oraz aktywację Konta w Serwisie,
          Użytkownik oświadcza, że:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                treść Regulaminu została Użytkownikowi nieodpłatnie udostępniona
                przed rozpoczęciem korzystania z Usług w ten sposób, że miał
                możliwość zapoznania się z jego treścią,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                zobowiązuje się do przestrzegania postanowień Regulaminu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                wszystkie informacje podane w formularzu rejestracyjnym są
                zgodne z prawdą.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>

      <ListItem>
        <ListItemIcon>3.7.</ListItemIcon>
        <ListItemText>
          Użytkownik może korzystać z Usług z chwilą zaakceptowania Regulaminu i
          aktywacji Konta, przez czas nieoznaczony.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.8.</ListItemIcon>
        <ListItemText>
          Administrator komunikuje się z Użytkownikiem w języku polskim.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.9.</ListItemIcon>
        <ListItemText>
          Użytkownik ma prawo odstąpienia od korzystania z Usług w terminie 14
          dni od dnia aktywacji Konta. Odstąpienie następuje poprzez złożenie
          Administratorowi oświadczenia, w wybranej przez Użytkownika formie
          komunikacji określonej w pkt. 9.2 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.10.</ListItemIcon>
        <ListItemText>
          Użytkownik uzyskuje dostęp do aktywnego Konta poprzez podanie
          prawidłowego Loginu oraz Hasła.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.11.</ListItemIcon>
        <ListItemText>
          W ramach Serwisu Użytkownik uzyskuje dostęp do następujących Usług:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                informacji umożliwiających identyfikację zadłużenia, dotyczących
                stanu zadłużenia oraz historii wpłat, z zastrzeżeniem pkt. 3.12,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                aktualnych propozycji Administratora dotyczących spłaty
                zobowiązań oraz możliwości zawarcia ugody,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                usługi ChatBot oraz kanału komunikacyjnego umożliwiającego
                kontakt z pracownikiem zajmującym się obsługą zadłużenia,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d)</ListItemIcon>
              <ListItemText>usługi udostępniania dokumentów,</ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>e)</ListItemIcon>
              <ListItemText>
                edycji danych teleadresowych Użytkownika.
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>f)</ListItemIcon>
              <ListItemText>
                możliwości dokonywania spłaty zadłużenia poprzez internetowy
                system płatności dostępny za pośrednictwem Serwisu.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>

      <ListItem>
        <ListItemIcon>3.12.</ListItemIcon>
        <ListItemText>
          Serwis może nie prezentować informacji o wszystkich zobowiązaniach
          osoby zadłużonej obsługiwanych przez Administratora. W celu
          potwierdzenia kompletności zadłużeń prezentowanych w Serwisie lub
          obsługiwanych przez Administratora, należy skontaktować się z
          Administratorem, w wybranej przez Użytkownika formie komunikacji
          określonej w pkt. 9.2 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.13.</ListItemIcon>
        <ListItemText>
          Podczas korzystania z Usług, Użytkownik jest zobowiązany do:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                przestrzegania przepisów prawa obowiązujących na terytorium
                Rzeczypospolitej Polskiej oraz postanowień tego Regulaminu,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                powstrzymania się od dostarczania treści o charakterze
                bezprawnym, a także od korzystania z Usług w sposób sprzeczny z
                zasadami współżycia społecznego i dobrymi obyczajami,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText>
                powstrzymania się od dostarczania treści zawierających złośliwe
                oprogramowanie lub które mogą wywołać zakłócenia lub uszkodzenia
                Serwisu lub systemów teleinformatycznych i komputerowych
                Administratora lub innych użytkowników,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d)</ListItemIcon>
              <ListItemText>
                podawania danych lub informacji, które są aktualne, zgodne z
                prawdą i niewprowadzające w błąd,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>e)</ListItemIcon>
              <ListItemText>
                nieprzekazywania danych logowania do Serwisu osobom
                nieuprawnionym.
              </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>

      <ListItem>
        <ListItemIcon>3.14.</ListItemIcon>
        <ListItemText>
          W przypadku zauważenia przez Użytkownika nieprawidłowości w działaniu
          Serwisu, Użytkownik jest zobowiązany do niezwłocznego poinformowania o
          tym fakcie Administratora, w wybranej przez siebie formie komunikacji
          określonej w pkt. 9.2 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.15.</ListItemIcon>
        <ListItemText>
          Administrator zablokuje dostęp do Konta w przypadku 3–krotnego podania
          nieprawidłowego Loginu bądź Hasła. Administrator może zablokować
          dostęp do Konta w przypadku naruszenia przez Użytkownika obowiązków
          określonych w pkt. 3.13 Regulaminu, powzięcia informacji o próbie lub
          ingerencji przez osoby trzecie w struktury systemów informatycznych
          obsługujących Serwis lub powzięcia informacji o próbie wejścia lub
          wejście w posiadanie Loginu lub Hasła Użytkownika przez nieupoważnione
          osoby trzecie. Procedura odblokowywania dostępu do Konta Użytkownika
          następuje po realizacji przez Użytkownika wszystkich kroków wskazanych
          na stronie internetowej Serwisu oraz za pośrednictwem adresu e–mail
          podanego przez Użytkownika podczas rejestracji.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.16.</ListItemIcon>
        <ListItemText>
          Administrator może wypowiedzieć świadczenie Usług na rzecz Użytkownika
          w przypadku naruszenia przez Użytkownika obowiązków określonych w pkt.
          3.13 Regulaminu.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.17.</ListItemIcon>
        <ListItemText>
          Poza przypadkiem określonym w pkt. 3.16 Regulaminu, Administrator może
          wypowiedzieć świadczenie Usług, z zachowaniem 14–dniowego terminu
          wypowiedzenia.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.18.</ListItemIcon>
        <ListItemText>
          Użytkownik może w każdej chwili zrezygnować z korzystania z Usług. W
          celu rezygnacji Użytkownik powinien poinformować o tym Administratora,
          w wybranej przez siebie formie komunikacji określonej w pkt. 9.2
          Regulaminu. Zawiadomienie Użytkownika o rezygnacji z korzystania z
          Usług (w tym w ramach komunikacji za pośrednictwem Chata) będzie
          stanowić podstawę do zablokowania Konta.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>3.19.</ListItemIcon>
        <ListItemText>
          Wszelkie spory mogące powstać lub wynikłe z korzystania z Serwisu lub
          z Usług rozstrzygane będą według prawa polskiego i przez polski sąd
          powszechny.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default TermsOfUseOfTheWebsite;
